import { observer } from "mobx-react-lite";
import WarningBeforeAction from "e.sic-platform.webclient/src/components/data-components/WarningBeforeAction";
import { Coin } from "../shop/Coin";
import { translationService } from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { activityPricesStorage, ActivityTypes } from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { useCallback, useEffect, useMemo, useState } from "react";
import { creditBalanceStorage } from "e.sic-platform.webclient/src/services/shop/CreditBalanceStorage";
import { Button, Menu, Stack } from "@mui/material";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { authentication } from "e.sic-platform.webclient/src/services/authentication/Authentication";
import OrderOverview from "./OrderOverview";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export interface IPurchaseConfirmation {
    visible: boolean;
    toggle(): void;
    apps: ActivityTypes[];
    confirm(): void;
}

export default observer(function PurchaseConfirmation(props: IPurchaseConfirmation) {
    const navigate = useNavigate();
    const price = activityPricesStorage.getPrices(props.apps);
    const [confirmationDisabled, setConfirmationDisabled] = useState(false);
    const [openPrice, setOpenPrice] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const openPriceMenu = useCallback((e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget);
        setOpenPrice(true);
    }, [])

    const closePriceMenu = useCallback(() => {
        setAnchorEl(null);
        setOpenPrice(false);
    }, [])

    const goToShop = useCallback(() => {
        navigate("/shop");
    }, [])

    useEffect(() => {
        creditBalanceStorage.validateRemainingBalance(props.apps).then((result) => {
            setConfirmationDisabled(!result);
        });
    }, [props.apps]);

    const warningKey = useMemo(() => {
        if (authentication.anonymous) return "shop.authentication-needed";
        if (confirmationDisabled) return "shop.balance-exceeded";
        return ""
    }, [authentication.anonymous, confirmationDisabled])

    return (
        <>
            <Button onClick={openPriceMenu} sx={{ml: 3}} variant="contained" endIcon={<KeyboardArrowDownIcon />}>
                <Coin color="default" amount={price} text={translationService.translate("general.apps.priceMenu.button")}/>
            </Button>
            <Menu
                open={openPrice}
                onClose={closePriceMenu}
                anchorEl={anchorEl}
                sx={{top: 5}}
            >
                <Stack p={3}>
                    <div>{translationService.translate("general.apps.priceMenu.description")}</div>
                    <OrderOverview price={price}/>
                    <Button onClick={goToShop} endIcon={<ArrowForward sx={{marginLeft: "auto"}}/>} variant="contained">{translationService.translate("general.apps.priceMenu.shopLink")}</Button>
                </Stack>
            </Menu>
            <WarningBeforeAction
                isVisible={props.visible}
                titleKey="shop.appPurchase.title"
                toggleModal={props.toggle}
                optionalWarningKey={warningKey}
                buttonOk={{
                    textKey: "shop.appPurchase.confirm",
                    action: () => {
                        props.confirm();
                        props.toggle();
                    },
                    disabled: confirmationDisabled
                }}
            >
                <div>{translationService.translate("shop.appPurchase.description")}</div>
                <Stack pr={8}>
                    <OrderOverview price={price}/>
                </Stack>
            </WarningBeforeAction>
        </>
    )
})